import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminApi";
import { Field } from "@/pages/admin/Field";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Users } from "lucide-react";

const empty = { name_en: "", name_gu: "", captain: "", players: [] };

export const TeamsSection = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [playersText, setPlayersText] = useState("");
  const [editId, setEditId] = useState(null);

  const load = () => api.gapl().then((d) => setRows(d.teams));
  useEffect(() => { load(); }, []);

  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const openNew = () => { setForm(empty); setPlayersText(""); setEditId(null); setOpen(true); };
  const openEdit = (tm) => { setForm(tm); setPlayersText((tm.players || []).join("\n")); setEditId(tm.id); setOpen(true); };

  const save = async () => {
    if (!form.name_en) { toast.error("Team name (English) is required"); return; }
    const players = playersText.split("\n").map((s) => s.trim()).filter(Boolean);
    const payload = { ...form, players };
    try {
      if (editId) await adminApi.updateTeam(editId, payload);
      else await adminApi.createTeam(payload);
      toast.success("Saved"); setOpen(false); load();
    } catch { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete this team?")) return; await adminApi.deleteTeam(id); toast.success("Deleted"); load(); };

  return (
    <div>
      <div className="mb-5 flex items-center justify-between">
        <h2 className="font-serif text-2xl font-semibold text-gmoaa-green">GAPL Teams</h2>
        <Button data-testid="team-add-btn" onClick={openNew} className="bg-gmoaa-green text-white hover:bg-gmoaa-green-hover"><Plus size={16} className="mr-1" /> Add</Button>
      </div>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {rows.map((tm) => (
          <div key={tm.id} className="flex items-start justify-between rounded-xl border border-gmoaa-border-subtle bg-white p-3">
            <div>
              <p className="font-medium text-gmoaa-text-dark">{tm.name_en}</p>
              <p className="text-xs text-gmoaa-saffron-hover">Captain: {tm.captain || "—"}</p>
              <p className="mt-1 flex items-center gap-1 text-xs text-gmoaa-text-muted"><Users size={12} /> {(tm.players || []).length} players</p>
            </div>
            <div className="flex gap-1">
              <Button size="sm" variant="ghost" onClick={() => openEdit(tm)}><Pencil size={15} /></Button>
              <Button size="sm" variant="ghost" className="text-gmoaa-red" onClick={() => del(tm.id)}><Trash2 size={15} /></Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] overflow-y-auto bg-gmoaa-cream">
          <DialogHeader><DialogTitle className="text-gmoaa-green">{editId ? "Edit" : "Add"} team</DialogTitle></DialogHeader>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <Field label="Team name (English)" value={form.name_en} onChange={set("name_en")} />
            <Field label="Team name (Gujarati)" value={form.name_gu} onChange={set("name_gu")} />
            <div className="sm:col-span-2"><Field label="Captain" value={form.captain} onChange={set("captain")} /></div>
            <div className="sm:col-span-2">
              <Field label="Players (one per line)" textarea value={playersText} onChange={setPlayersText} placeholder={"Abhishek (C)\nAkash\nBhupendra"} />
            </div>
          </div>
          <DialogFooter><Button onClick={save} className="bg-gmoaa-green text-white hover:bg-gmoaa-green-hover">Save</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
